import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { activateModal } from '../../store/actions';

import svgInline from '../SvgInline/SvgInline';
import folderIcon from './icon-folder.svg';
import folderIconActive from './icon-folder-active.svg';

export function ListMenuComponent({
  properties,
  type,
  handleModalOpen,
  onAddToFavoritesClick,
  // dontShowAgain,
  // authenticated,
}) {
  // Team LOIS has requested the functionality for notifying a user they are not logged
  // into favorites be removed for now. The functionality will be commented out for when
  // they as to have it re-implemented.

  // const modalType = (dontShowAgain || authenticated) ? 'folders' : 'first-time';
  const modalType = 'folders';
  return (
    <div className="list-menu">
      <div className="list-menu-option">
        <a
          onClick={() => {
            handleModalOpen({ properties, propertyType: type, type: modalType, action: 'save-all' });
            onAddToFavoritesClick();
          }}
          tabIndex="0"
        >
          {svgInline(folderIconActive)} Add All To Folders
        </a>
      </div>
      <div className="list-menu-option">
        <a
          onClick={() => {
            handleModalOpen({ properties, propertyType: type, type: 'folders', action: 'remove-all' });
            onAddToFavoritesClick();
          }}
          tabIndex="0"
        >
          {svgInline(folderIcon)} Remove All From Folders
        </a>
      </div>
    </div>
  );
}

ListMenuComponent.propTypes = {
  properties: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string,
  })).isRequired,
  type: PropTypes.string.isRequired,
  handleModalOpen: PropTypes.func,
  onAddToFavoritesClick: PropTypes.func,
  // dontShowAgain: PropTypes.bool,
  // authenticated: PropTypes.bool,
};

export function mapStateToProps({ favorites, profile }) {
  return {
    dontShowAgain: favorites.dontShow,
    authenticated: profile.authenticated,
  };
}

export function mapDispatchToProps(dispatch) {
  return {
    activateFavoriteModal: whichModal => { dispatch(activateModal(whichModal)); },
  };
}

export function mergeProps(propsFromState, propsFromDispatch, ownProps) {
  // const checkValue = (propsFromState.authenticated || propsFromState.dontShowAgain);
  return {
    // onAddToFavoritesClick: () =>
    //   (checkValue
    //     ? propsFromDispatch.activateFavoriteModal('folders')
    //     : propsFromDispatch.activateFavoriteModal('first-time')),
    onAddToFavoritesClick: () => propsFromDispatch.activateFavoriteModal('folders'),
    ...propsFromState,
    ...ownProps,
  };
}

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ListMenuComponent);



// WEBPACK FOOTER //
// ./src/components/List/ListMenu.js